import { render } from "./card-isdn.vue?vue&type=template&id=9917999a"
import script from "./card-isdn.vue?vue&type=script&lang=js"
export * from "./card-isdn.vue?vue&type=script&lang=js"

import "./card-isdn.vue?vue&type=style&index=0&id=9917999a&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__